/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';
import { Oas20Document } from '../../v2/models/Oas20Document';
import { Oas20Parameter } from '../../v2/models/Oas20Parameter';
import { Oas20ParameterDefinition } from '../../v2/models/Oas20ParameterDefinition';
import { Oas20Response } from '../../v2/models/Oas20Response';
import { Oas20ResponseDefinition } from '../../v2/models/Oas20ResponseDefinition';
import { Oas20Schema } from '../../v2/models/Oas20Schema';
import { Oas20SchemaDefinition } from '../../v2/models/Oas20SchemaDefinition';
import { AbstractReferenceLocalizationStrategy } from './AbstractReferenceLocalizationStrategy';

export class Oas20IReferenceManipulationStrategy extends AbstractReferenceLocalizationStrategy implements IReferenceManipulationStrategy {
    PREFIX : string;

    /**
     * 
     * @param {Document} document
     * @param {string} name
     * @param {Node} component
     * @return {IReferenceManipulationStrategy.ReferenceAndNode}
     */
    public attachAsDefinition(document : Document, name : string, component : Node) : IReferenceManipulationStrategy.ReferenceAndNode {
        if(!(document != null && document instanceof <any>Oas20Document)) throw Object.defineProperty(new Error("Oas20Document expected."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
        let model : Oas20Document = <Oas20Document>document;
        if(component != null && component instanceof <any>Oas20Schema) {
            if(model.definitions == null) model.definitions = model.createDefinitions();
            if(model.definitions.getDefinition(name) != null) throw Object.defineProperty(new Error("Definition with that name already exists: " + name), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
            let definition : Oas20SchemaDefinition = <any>(this.wrap<any>(component, new Oas20SchemaDefinition(name), model));
            definition.attachToParent(model.definitions);
            model.definitions.addDefinition(definition.getName(), definition);
            return new IReferenceManipulationStrategy.ReferenceAndNode(this.PREFIX + "definitions/" + name, definition);
        }
        if(component != null && component instanceof <any>Oas20Parameter) {
            if(model.parameters == null) model.parameters = model.createParameterDefinitions();
            if(model.parameters.getParameter(name) != null) throw Object.defineProperty(new Error("Definition with that name already exists: " + name), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
            let definition : Oas20ParameterDefinition = <any>(this.wrap<any>(component, new Oas20ParameterDefinition(name), model));
            definition.attachToParent(model.parameters);
            model.parameters.addParameter(definition.getName(), definition);
            return new IReferenceManipulationStrategy.ReferenceAndNode(this.PREFIX + "parameters/" + name, definition);
        }
        if(component != null && component instanceof <any>Oas20Response) {
            if(model.responses == null) model.responses = model.createResponseDefinitions();
            if(model.responses.getResponse(name) != null) throw Object.defineProperty(new Error("Definition with that name already exists: " + name), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
            let definition : Oas20ResponseDefinition = <any>(this.wrap<any>(component, new Oas20ResponseDefinition(name), model));
            definition.attachToParent(model.responses);
            model.responses.addResponse(definition.getName(), definition);
            return new IReferenceManipulationStrategy.ReferenceAndNode(this.PREFIX + "responses/" + name, definition);
        }
        return null;
    }

    /**
     * 
     * @param {Document} document
     * @return {*}
     */
    public getExistingLocalComponents(document : Document) : any {
        if(!(document != null && document instanceof <any>Oas20Document)) throw Object.defineProperty(new Error("Oas20Document expected."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
        let model : Oas20Document = <Oas20Document>document;
        let res : any = <any>({});
        if(model.definitions != null) this.transform(model.definitions.items, (name) => this.PREFIX + "definitions/" + name, res);
        if(model.parameters != null) this.transform(model.parameters.items, (name) => this.PREFIX + "parameters/" + name, res);
        if(model.responses != null) this.transform(model.responses.items, (name) => this.PREFIX + "responses/" + name, res);
        return res;
    }

    constructor() {
        super();
        this.PREFIX = "#/";
    }
}
Oas20IReferenceManipulationStrategy["__class"] = "io.apicurio.datamodels.openapi.visitors.dereference.Oas20IReferenceManipulationStrategy";
Oas20IReferenceManipulationStrategy["__interfaces"] = ["io.apicurio.datamodels.openapi.visitors.dereference.IReferenceManipulationStrategy"];





import { IReferenceManipulationStrategy } from './IReferenceManipulationStrategy';

